import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { Redirect } from "react-router-dom";
import classNames from "classnames/bind";
import Loader from "../Loader3/Loader";
import styles from "./styles.scss";

const cx = classNames.bind(styles);

export default function Protected({ children, requireLogin }) {
  const isLoading = useSelector(state => !state.auth.loaded);
  const isLoggedIn = useSelector(state => !!state.auth.user);

  if (isLoading) {
    return (
      <div className={cx("loading-container")}>
        <Loader />
      </div>
    );
  }
  if (requireLogin && !isLoggedIn) {
    return <Redirect to="/" />;
  }
  return children;
}
Protected.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.arrayOf(PropTypes.element)]),
  requireLogin: PropTypes.bool,
};
Protected.defaultProps = {
  requireLogin: false,
  children: [],
};
